const _Permission = {
  //the new permission still nedded extra adding
  PAYROLL_WRITE: 1n << 18n,

  CARDS_VIEW_READ: 1n << 1n,
  CARDS_VIEW_WRITE: 1n << 2n,
  CARD_VIEW_CAREER_DETAILS: 1n << 3n,
  CARD_VIEW_OWN_PAGE: 1n << 4n,

  CLIENT_READ: 1n << 5n,
  CLIENT_WRITE: 1n << 6n,

  PROJECT_READ: 1n << 7n,
  PROJECT_WRITE: 1n << 8n,

  STAFFING_READ: 1n << 9n,
  STAFFING_WRITE: 1n << 10n,

  PROMOTION_READ: 1n << 11n,
  PROMOTION_IDENTIFY_CANDIDATE: 1n << 12n,
  PROMOTION_MANAGE_CANDIDATE: 1n << 13n,
  PROMOTION_COMMIT: 1n << 120n,

  EVALUATION_READ: 1n << 14n,
  EVALUATION_WRITE: 1n << 15n,
  EVLUATION_ASSIGN_REVIEWERS: 1n << 121n,

  POOL_READ: 1n << 16n,
  POOL_WRITE: 1n << 17n,

  NOTIFICATION_READ: 1n << 20n,

  SALARIES_READ: 1n << 21n,
  SALARIES_WRITE: 1n << 22n,

  CONFIGURATION_READ: 1n << 23n,
  CONFIGURATION_WRITE: 1n << 24n,

  USER_MANAGEMENT_READ: 1n << 25n,
  USER_MANAGEMENT_WRITE: 1n << 26n,

  FINANCE_READ: 1n << 27n,
  FINANCE_WRITE: 1n << 28n,

  AUDIT_LOG_READ: 1n << 30n,

  BSA_ORG_READ: 1n << 31n,
  BSA_ORG_WRITE: 1n << 32n,

  INVOICING_ADMINISTRATION: 1n << 33n,

  CONFIG_STAFFING: 1n << 34n,
  CONFIG_BSA: 1n << 35n,
  CONFIG_INVOICING: 1n << 36n,
  CONFIG_PERFORMANCE: 1n << 37n,
  CONFIG_USER_MANAGEMENT: 1n << 38n,

  INVOICING_READ: 1n << 39n,
  INVOICING_SERVICE: 1n << 40n,
  INVOICING_ADMIN: 1n << 41n,

  PROMOTION_CONFIRM_IDENTIFICATION: 1n << 42n,
  PROMOTION_SCHEDULE_INTERVIEW: 1n << 43n,

  CARD_VIEW_VALIDATE_ROLE: 1n << 44n,
  SALARY_VALIDATE: 1n << 45n,

  FEEDBACK_ASSIGNED_HANDLER: 1n << 46n,
  FEEDBACK_ASSIGNMENT_MANAGER: 1n << 47n,

  MANAGER_READ: 1n << 48n,
  MANAGER_WRITE: 1n << 49n,

  PEOPLE_READ: 1n << 50n,
  PEOPLE_WRITE: 1n << 51n,

  DIRECTOR_READ: 1n << 100n,
  DIRECTOR_WRITE: 1n << 101n,

  OPPORTUNITY_READ: 1n << 52n,
  OPPORTUNITY_WRITE: 1n << 53n,

  DEMAND_READ: 1n << 54n,
  DEMAND_WRITE: 1n << 55n,

  PEOPLE_AT_RISK_READ: 1n << 56n,
  PEOPLE_AT_RISK_WRITE: 1n << 57n,

  BILLING_READ: 1n << 58n,
  BILLING_WRITE: 1n << 59n,

  PEOPLE_WITH_BAD_ATTITUDE_READ: 1n << 60n,
  PEOPLE_WITH_BAD_ATTITUDE_WRITE: 1n << 61n,

  CARD_VIEW_CAREER_DETAILS_WRITE: 1n << 62n,

  CARD_VIEW_OVERVIEW_READ: 1n << 63n,
  CARD_VIEW_OVERVIEW_WRITE: 1n << 64n,

  CARD_VIEW_CIVIL_STATE_DETAILS_READ: 1n << 65n,
  CARD_VIEW_CIVIL_STATE_DETAILS_WRITE: 1n << 66n,

  CARD_VIEW_LOCATION_DETAILS_READ: 1n << 67n,
  CARD_VIEW_LOCATION_DETAILS_WRITE: 1n << 68n,

  CARD_VIEW_SOCIAL_SECURITY_DETAILS_READ: 1n << 69n,
  CARD_VIEW_SOCIAL_SECURITY_DETAILS_WRITE: 1n << 70n,

  CARD_VIEW_CONTRACT_DETAILS_READ: 1n << 71n,
  CARD_VIEW_CONTRACT_DETAILS_WRITE: 1n << 72n,

  CARD_VIEW_EDUCATION_READ: 1n << 73n,
  CARD_VIEW_EDUCATION_WRITE: 1n << 74n,

  CARD_VIEW_LANGUAGES_READ: 1n << 75n,
  CARD_VIEW_LANGUAGES_WRITE: 1n << 76n,

  CARD_VIEW_FINANCIAL_DETAILS_READ: 1n << 77n,
  CARD_VIEW_FINANCIAL_DETAILS_WRITE: 1n << 78n,

  CARD_VIEW_DOCUMENTS_READ: 1n << 79n,
  CARD_VIEW_DOCUMENTS_WRITE: 1n << 80n,

  CARD_VIEW_EQUIPMENT_READ: 1n << 81n,
  CARD_VIEW_EQUIPMENT_WRITE: 1n << 82n,

  CARD_VIEW_MEDICAL_VISIT_READ: 1n << 83n,
  CARD_VIEW_MEDICAL_VISIT_WRITE: 1n << 84n,

  CARD_VIEW_PAY_SLIP_READ: 1n << 85n,
  CARD_VIEW_PAY_SLIP_WRITE: 1n << 86n,

  CARD_VIEW_CERTIFICATIONS_DOWNLOAD: 1n << 87n,

  CARD_VIEW_SKILLS_READ: 1n << 89n,
  CARD_VIEW_SKILLS_WRITE: 1n << 90n,

  JUNIOR_PROMOTION_NOTIFICATION: 1n << 91n,
  TRIAL_PERIOD_ENDING_NOTIFICATION: 1n << 92n,
  CONTRACT_ENDING_NOTIFICATION: 1n << 93n,


  CARD_VIEW_SALARY_ADVANCES_READ: 1n << 94n,
  CARD_VIEW_SALARY_ADVANCES_WRITE: 1n << 95n,

  CARD_VIEW_BASIC_EMPLOYEE_INFO: 1n << 96n,

  CARD_VIEW_AFMA_READ: 1n << 97n,
  CARD_VIEW_AFMA_WRITE: 1n << 98n,

  Extra_OnCall_Export: 1n << 102n,

  DASHBOARD_GLOBAL: 1n << 103n,
  DASHBOARD_CLIENT: 1n << 104n,
  DASHBOARD_LEADER: 1n << 105n,
  DASHBOARD_LANGUAGE: 1n << 106n,
  DASHBOARD_PROMOTION: 1n << 107n,
  DASHBOARD_MEDICAL_VISIT: 1n << 125n,

  // Export/Import actions in the Cards View / List View "Options" menu.
  // Each one gates a single menu entry; see search.component.ts buildMenuItems().
  EXPORT_IMPORT_IMPORT_EMPLOYEE: 1n << 108n,
  EXPORT_IMPORT_IMPORT_EMPLOYEES: 1n << 109n,
  EXPORT_IMPORT_MISSING_DOCUMENTS: 1n << 110n,
  EXPORT_IMPORT_SENIORITY: 1n << 111n,
  EXPORT_IMPORT_AFMA: 1n << 112n,
  EXPORT_IMPORT_MEDICAL_VISIT: 1n << 113n,
  EXPORT_IMPORT_SCHOOL_GRANT: 1n << 114n,
  EXPORT_IMPORT_STAFFING_BSA: 1n << 115n,
  EXPORT_IMPORT_STAFFING_PRODUCTION: 1n << 116n,
  EXPORT_IMPORT_PAY_SLIP: 1n << 117n,
  EXPORT_IMPORT_SALARY: 1n << 118n,

  // Gates the Export/Import section under Configurations. That page does not exist
  // yet; wire it up in route-permissions.config.ts when it is built.
  CONFIG_EXPORT_IMPORT: 1n << 119n,
  MANAGER_PEOPLE: 1n << 122n,

  // Grants the behaviour historically reserved to members of the BSA practice (now G&A):
  // cross-practice visibility and the BSA actions on the notification pages. The user's
  // practice name must no longer be used for those rules.
  BSA: 1n << 123n,

  // Gates the Production menu (Service, Unassigned people, People with supervisor).
  PRODUCTION: 1n << 124n,

    // ── Internship Management ──
  INTERNSHIP_REQUEST_READ: 1n << 126n,
  INTERNSHIP_REQUEST_WRITE: 1n << 127n,
  INTERNSHIP_PEOPLE_INTERVIEW_READ: 1n << 128n,
  INTERNSHIP_PEOPLE_INTERVIEW_WRITE: 1n << 129n,
  INTERNSHIP_TECHNICAL_INTERVIEW_READ: 1n << 130n,
  INTERNSHIP_TECHNICAL_INTERVIEW_WRITE: 1n << 131n,
  INTERNSHIP_DOCUMENTS_READ: 1n << 132n,
  INTERNSHIP_DOCUMENTS_WRITE: 1n << 133n,
  INTERNSHIP_CREDENTIALS_READ: 1n << 134n,
  INTERNSHIP_CREDENTIALS_WRITE: 1n << 135n,
  INTERNSHIP_FEEDBACK_READ: 1n << 136n,
  INTERNSHIP_FEEDBACK_WRITE: 1n << 137n,
  INTERNSHIP_LISTS_READ: 1n << 138n,
  INTERNSHIP_LISTS_WRITE: 1n << 139n,
} as const;

export const Permission = Object.freeze(_Permission);

export type PermissionKey = keyof typeof Permission;
export type PermissionBit = (typeof Permission)[PermissionKey];

export const PermissionBits = Permission;
